import { Component } from '@angular/core';
import { NavController, NavParams, Platform } from 'ionic-angular';
// import { PhotoLibrary } from '@ionic-native/photo-library';
import { PhotoLibrary } from './../../../providers/my-photo-library';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { AbstractPage } from '../../_com/abstract-page';

/**
 * Generated class for the PhotoRequestCompletePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-photo-request-complete',
  templateUrl: 'photo-request-complete.html',
})
export class PhotoRequestCompletePage extends AbstractPage{

  photoRequest = {};

  constructor(
  	public navCtrl: NavController
  	, public navParams: NavParams
  	, private pv:PhotoViewer
  	, private pl:PhotoLibrary
  	, private plt:Platform) {
  	super();

  	this.pl;
    this.pv;
    this.plt;
  }

  ionViewDidLoad() {
  	this.photoRequest = this.navParams.data["PhotoRequest"];
  }

}



// WEBPACK FOOTER //
// ./src/pages/photo-request/complete/photo-request-complete.ts